export const REGULARS = {
	phoneNumber: /^\+[0-9\s]*$/,
	nonDigits: /[^0-9]*/gi,
	phoneNumberWithPlus: /^\+[^0-9]/g,
	pathId: /:id/,
	documentName: /([^/]+$)/,
};
